// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1u75q","overflowing":"ReadFullNote_overflowing__Shv44"};